import { render, staticRenderFns } from "./GradeSelectbox.vue?vue&type=template&id=4c4de630"
import script from "./GradeSelectbox.vue?vue&type=script&lang=js"
export * from "./GradeSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports